export enum EContractProfile {
  Courier = "Courier",

  StoreOwner = "StoreOwner",

  Customer = "Customer",
}
